import React, { useEffect } from 'react'
import { Switch, Route } from 'react-router-dom'
import { initApp } from '@helpers'
import HomePage from '@components/HomePage'
import { useColorScheme } from 'react-native-web'

import Icons from '../media/icons.svg'
import { Auth } from './auth'
import { useThemeContext } from '@gopeerproject/ui-kit'

const App = () => {
  const { colorScheme, setColorScheme } = useThemeContext()
  const nativeColorScheme = useColorScheme()

  useEffect(() => {
    initApp()
  }, [])

  useEffect(() => {
    const userTheme = localStorage.getItem('profile_theme')
    if (userTheme) {
      setColorScheme(userTheme === 'auto' ? nativeColorScheme : userTheme)
    }
  }, [nativeColorScheme, setColorScheme])

  return (
    <div className={`app app--${colorScheme}`}>
      <span
        style={{ display: 'none' }}
        dangerouslySetInnerHTML={{ __html: Icons }}
      />
      <div id='modal' style={{ zIndex: 999 }}></div>
      <Switch>
        <Route exact path='/' component={HomePage} />
        <Auth />
      </Switch>
    </div>
  )
}

export default App
